// bam.jpath.js - is a library that allows filtering of JSON data based on pattern-like expression

define('jpath/jpath',['require','exports','module'],function( require, exports, module ) {
	var TRUE = !0,
		FALSE = !1,
		STRING = "string",
		PERIOD = ".",
		undef,
		rxTokens = new RegExp("([A-Za-z0-9_\\*@\\$\\-]+(?:\\[.+?\\])?)", "g"),
		rxIndex = new RegExp("(\\S+)\\[(\\d+)\\]"),
		rxPairs = new RegExp("([\\w@\\.]+)\\s*([><=]=?|[~\\^\\$\\!\\*]=|\\?|!\\*)\\s*([@\\w\\s_\\'$\\.\\+-\\/\\:]+)(\\s*|$)", "g"),
		rxCondition = new RegExp("(\\S+)\\[(.+)\\]"),

		app = Array.prototype.push,
		apc = Array.prototype.concat,

		hidden = {
			toArray: function(o) {
				return o instanceof Array ? o : (o === undef || o === null) ? [] : [o];
			},
			traverse: function(pattern, cfn, obj) {
				var out, data = (obj || this.data),
					temp, tokens, token, idxToken, index, expToken, condition, tail, self = arguments.callee,
					found, i, j, l;
				if (data && typeof(pattern) === STRING) {
					tokens = pattern.match(rxTokens); //dot notation splitter
					//Get first token
					token = tokens[0];
					//Trailing tokens
					tail = tokens.slice(1).join(PERIOD);

					if (data instanceof Array) {
						temp = [];
						for (i = 0, l = data.length; l > i; i++) {
							j = data[i];
							found = self.apply(this, [token, cfn, j]);
							if (((found instanceof Array) && found.length) || found !== undef) {
								app.apply(temp, [found]);
							}
						}
						if (temp.length) {
							return tail ? self.apply(this, [tail, cfn, temp]) : temp;
						} else {
							return;
						}
					} else if (token === "*") {
						return tail ? self.apply(this, [tail, cfn, data]) : data;
					} else if (data[token] !== undef) {
						return tail ? self.apply(this, [tail, cfn, data[token]]) : data[token];
					} else if (rxIndex.test(token)) {
						idxToken = token.match(rxIndex);
						token = idxToken[1];
						index = +idxToken[2];
						return tail ? self.apply(this, [tail, cfn, data[token][index]]) : data[token][index];
					} else if (rxCondition.test(token)) {
						expToken = token.match(rxCondition);
						token = expToken[1];
						condition = expToken[2];

						var evalStr, isMatch, subset = token === "*" ? data : data[token],
							elem;

						if ($.isArray(subset)) {
							temp = [];
							//Second loop here is faster than recursive call
							for (i = 0, l = subset.length; l > i; i++) {
								elem = subset[i];
								//Convert condition pairs to booleans
								evalStr = condition.replace(rxPairs, function($0, $1, $2, $3) {
									return hidden.testPairs.apply(elem, [$1, $3, $2, cfn]);
								});
								//Evaluate expression
								isMatch = eval(evalStr);
								if (isMatch) {
									app.apply(temp, [elem]);
								}
							}
							if (temp.length) {
								return tail ? self.apply(this, [tail, cfn, temp]) : temp;
							} else {
								return;
							}
						} else {
							// if(!rxPairs.test(condition)){
							// 	throw new Error("Unsupported condition expression");
							// }
							elem = subset;
							//Convert condition pairs to booleans
							evalStr = condition.replace(rxPairs, function($0, $1, $2, $3) {
								return hidden.testPairs.apply(elem, [$1, $3, $2, cfn]);
							});
							//Evaluate expression
							isMatch = eval(evalStr);
							if (isMatch) {
								return tail ? self.apply(this, [tail, cfn, elem]) : elem;
							}
						}
					}
				}
				return out;
			},
			//Matches type of a to b
			matchTypes: function(a, b) {
				var _a, _b;
				switch (typeof(a)) {
				case "string":
					_b = b + '';
					break;
				case "boolean":
					_b = b === "true" ? TRUE : FALSE;
					break;
				case "number":
					_b = +b;
					break;
				case "date":
					_b = new Date(b).valueOf();
					_a = a.valueOf();
					break;
				default:
					_b = b;
				}
				if (b === "null") {
					_b = null;
				}
				if (b === "undefined") {
					_b = undef;
				}
				return {
					left: (_a || a),
					right: _b
				};
			},
			testPairs: (function() {
				var conditions = {
					"=": function(l, r) {
						return l === r;
					},
					"==": function(l, r) {
						return l === r;
					},
					"!=": function(l, r) {
						return l !== r;
					},
					"^=": function(l, r) {
						return !((l + '').indexOf(r));
					},
					"<": function(l, r) {
						return l < r;
					},
					"<=": function(l, r) {
						return l <= r;
					},
					">": function(l, r) {
						return l > r;
					},
					">=": function(l, r) {
						return l >= r;
					},
					"~=": function(l, r) {
						return (l + '').toLowerCase() === (r + '').toLowerCase();
					},
					"$=": function(l, r) {
						return new RegExp(r + "$", "i").test(l);
					},
					"*=": function(l, r) {
						return (l + '').indexOf(r) >= 0;
					},
					"!*": function(l, r) {
						return (l + '').indexOf(r) < 0;
					}
				};

				return function(left, right, operator, fn) {
					if (operator !== "?" && !(operator in conditions)) {
						throw new Error("Unsupported operation (" + operator + ")");
					}
					var out = FALSE,
						leftVal = left.indexOf(PERIOD) !== -1 ? hidden.traverse(left, null, this) : this[left],
						pairs = hidden.matchTypes(leftVal, $.trim(right));
					if (operator === "?") {
						if ($.isFunction(fn)) {
							out = fn.call(this, pairs.left, right);
						}
					} else {
						out = conditions[operator](pairs.left, pairs.right);
					}
					return out;
				};
			})(),
			merge: function(pattern) {
				var out = [],
					temp = hidden.toArray(pattern ? hidden.traverse.apply(this, arguments) : this.selection);
				out = apc.apply([], temp);
				return out;
			}
		};



	function JPath(obj) {
		if (!(this instanceof JPath)) {
			return new JPath(obj);
		}
		this.data = obj || null;
		this.selection = [];
	}

	JPath.prototype = {
		from: function(obj) {
			this.data = obj;
			return this;
		},
		first: function() {
			return this.selection.length ? this.selection[0] : null;
		},
		last: function() {
			return this.selection.length ? this.selection.slice(-1)[0] : null;
		},
		eq: function(idx) {
			return this.selection.length ? this.selection[idx] : null;
		},
		select: function(pattern, cfn, obj) {
			this.selection = hidden.merge.apply(this, arguments);
			return this;
		},
		and: function(pattern) {
			this.selection = this.selection.concat(hidden.merge.apply(this, arguments));
			return this;
		},
		val: function() {
			return this.selection;
		}
	};

	exports.select = function(obj, pattern, cfn) {
		return new JPath(obj).select(pattern, cfn, null);
	};
	exports.JPath = JPath;
	//Backwards compatibility 1.0
	exports.filter = function(obj, pattern, cfn) {
		return new JPath(obj).select(pattern, cfn, null).val();
	};


});

